import { useState } from "react";
import {
  Box,
  Typography,
  IconButton,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { Images } from "../../../utils/Images";

const FaqWithTabs = ({ tab = "donors", items = null }) => {
  const [openItems, setOpenItems] = useState([]);
 
  const theme = useTheme();
  const isMediumScreen = useMediaQuery(
    "(min-width: 900px) and (max-width: 1200px)"
  );
  // Custom media query for screens below 900px
  const isSmallScreen = useMediaQuery("(max-width: 899px)");
  // Custom media query for mobile screens (600px and below)
  const isMobile = useMediaQuery("(max-width: 600px)");
  const isBelow1300 = useMediaQuery("(max-width: 1300px)");

  const currentFaqData = Array.isArray(items) && items.length
    ? items
    : [];

  const toggleItem = (index) => {
    setOpenItems((prev) =>
      prev.includes(index)
        ? prev.filter((item) => item !== index)
        : [...prev, index]
    );
  };

  return (
    <Box
      sx={{
        width: "100%",
      }}
    >
      <Box
        sx={{
          width: "100%",
          mx: "auto",
          display: "flex",
          flexDirection: "column",
          alignItems: isMobile ? "start" : isBelow1300 ? "center" : "center",
          background: "#FFFFFF",
          borderRadius: "20px",
        }}
      >
        {/* FAQ List */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
            width: "100%",
          }}
        >
          {currentFaqData.map((item, index) => (
            <Box
              key={index}
              sx={{
                bgcolor: "#fff",
                borderRadius: "12px",
                boxShadow: "0 5px 16px 0 rgba(8, 15, 52, 0.06)",
                border: "1px solid #FFFFFF",
                p: isMobile
                  ? 2
                  : isBelow1300
                  ? "20px 30px 20px 20px"
                  : "25px 40px 25px 25px",
                transition: "box-shadow 0.2s",
              }}
            >
              {/* Question Row */}
              <Box
                onClick={() => toggleItem(index)}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  cursor: "pointer",
                  pb: openItems.includes(index) ? 1 : 0,
                  gap: 2,
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    color: "#1D1D1B",
                    fontSize: isMobile ? "12px" : isBelow1300 ? "14px" : "18px",
                    fontWeight: 700,
                    pr: 1,
                  }}
                >
                  {item.question}
                </Typography>
                <IconButton
                  disableRipple
                  sx={{
                    width: isMobile ? "12px" : 26,
                    height: isMobile ? "12px" : 26,
                    bgcolor: openItems.includes(index) ? "#A9C74E" : "#A9C74E",
                    borderRadius: isMobile ? "1.927px" : "4px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    p: 0,
                    transition: "all 0.2s",
                  }}
                >
                  <img
                    src={
                      openItems.includes(index)
                        ? Images.arrowUpWhite
                        : Images.arrowDownWhite
                    }
                    alt={openItems.includes(index) ? "Collapse" : "Expand"}
                    style={{
                      width: isMobile ? "8px" : 18,
                      height: isMobile ? "8px" : 18,
                    }}
                  />
                </IconButton>
              </Box>

              {/* Answer */}
              {openItems.includes(index) && (
                <Typography
                  sx={{
                    color: "#6F6C90",
                    fontSize: isBelow1300 ? "12px" : "14px",
                    fontWeight: 400,
                    mt: isMobile ? 0.5 : "14px",
                    lineHeight: 1.6,
                  }}
                >
                  {item.__html ? (
                    <Box
                      component="div"
                      sx={{
                        '&, & *': {
                          color: '#6F6C90 !important',
                        },
                        '& ul': {
                          listStyle: 'disc',
                          paddingLeft: '1.2rem',
                        },
                        '& ol': {
                          listStyle: 'decimal',
                          paddingLeft: '1.2rem',
                        },
                        '& a': {
                          textDecoration: 'none',
                        },
                      }}
                      dangerouslySetInnerHTML={{ __html: item.__html }}
                    />
                  ) : (
                    item.answer
                  )}
                </Typography>
              )}
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default FaqWithTabs;
